export default __webpack_public_path__ + "static/media/globalfunds.75188f88.webp";